import { useEffect, useState } from 'react'
import { getTpShowReleaseStatus } from '../../../services/api/https/settings/tp.http'

// Indica se o TP exibe o status de liberação das entregas (suspenso/liberado) nas telas
// 3.4 e 3.9. Desligado por padrão e em caso de erro: a tela fica como antes.
export default function useShowReleaseStatus(tpId) {
  const [show, setShow] = useState(false)

  useEffect(() => {
    let active = true
    setShow(false)
    if (!tpId) return undefined
    getTpShowReleaseStatus(tpId)
      .then(value => active && setShow(value))
      .catch(() => active && setShow(false))
    return () => {
      active = false
    }
  }, [tpId])

  return show
}
